@if (this.loginService.systemConf === 'devkitoolbox' || this.loginService.systemConf === 'localkitoolbox') {
  <div
    class="position-fixed server-tag bg-primary fs-5 text-white"
  >DEV</div>
}
@if (this.loginService.systemConf === 'stagingkitoolbox') {
  <div
    class="position-fixed server-tag fs-5 text-white"
    style="background-color: #1369a2"
  >STAGING</div>
}
@if (!isFullScreenLayout) {
  <div style="height: 100vh; display: flex; flex-direction: column;flex:1 1">
    <div id="main">
      <router-outlet></router-outlet>
    </div>
  </div>
}
@if (isFullScreenLayout) {
  <router-outlet></router-outlet>
}